import React, { Component } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

export default class About extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <section id="about">
        <div className="row">
          <div className="three columns">
            <LazyLoadImage
              className="profile-pic"
              src="images/profilepic.png"
              alt="Amit Dimri profile pic"
              effect="blur"
            />
          </div>

          <div className="nine columns main-col">
            <h2>About Me</h2>
            <p className="about-content">{resumeData.aboutme}</p>
            <p className="about-content">
              <i className="fa fa-solid fa-heart" style={{ color: "red" }} />{" "}
              Cooking
            </p>

            <div className="row">
              <div className="twelve columns">
                <ul className="social">
                  {resumeData.socialLinks &&
                    resumeData.socialLinks.map((item) => {
                      return (
                        <li key={item.name}>
                          <a
                            href={item.url}
                            target="_blank"
                            rel="noreferrer noopener"
                          >
                            <i className={item.className} />
                          </a>
                        </li>
                      );
                    })}
                </ul>
              </div>
            </div>

            <div className="row">
              <div className="columns contact-details">
                <h2>Contact Details</h2>
                <div className="address">
                  {resumeData.contact.map((v) => (
                    <div key={v.name}>
                      <span>
                        <i className={v.className} />
                        &nbsp;&nbsp;
                        {v.value}
                      </span>
                      <br />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
